const dotPagination = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "rounded",
  py: "s100",
  px: "s100",
  gap: "s200",
  width: "fit-content",
  alignSelf: "center",

  '& [data-id="pagination-track"]': {
    alignItems: "center",
    listStyle: "none",
    p: 0,
    width: "fit-content",
    transition: "transform 240ms ease",

    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },

    "& [data-id='pagination-dot']": {
      alignItems: "center",
      justifyContent: "center",
      opacity: 0.24,
      transition: "opacity 240ms ease-in-out",

      ":after": {
        content: "''",
        display: "block",
        borderRadius: "full",
        transform: "scale(1)",
        transition: "transform 240ms ease-in-out",
      },

      '&[data-active="true"]': {
        opacity: 1,
      },
      '&[data-reduced="true"]:after': {
        transform: "scale(0.6)",
      },

      "@media (prefers-reduced-motion: reduce)": {
        transition: "none",

        "&:after": {
          transition: "none",
        },
      },
    },
  },
};

export const brand = {
  ...dotPagination,
  bg: "backgroundBrandDarkStatic",
  "& [data-id='pagination-dot']:after": {
    bg: "white",
  },
};

export const neutralPrimary = {
  ...dotPagination,
  bg: "backgroundPrimary",
  "& [data-id='pagination-dot']:after": {
    bg: "textBrandLevel2",
  },
};

export const neutralLevel2 = {
  ...dotPagination,
  bg: "backgroundLevel2",
  "& [data-id='pagination-dot']:after": {
    bg: "textBrandLevel2",
  },
};
